module.exports = __webpack_public_path__ + "assets/logo-horizontal-colour.b7457111.svg";